module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "issue"
  }, [(_vm.smallMode) ? _c('div', {
    staticClass: "row no-gutters"
  }, [_c('div', {
    staticClass: "col-auto mb-3",
    class: {
      'hidden-md-up': _vm.smallMode
    }
  }, [(_vm.coverUrl) ? _c('img', {
    staticClass: "issue-cover",
    attrs: {
      "src": _vm.coverUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col",
    class: {
      'hidden-md-up': _vm.smallMode
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.hideType) ? _c('div', {
    staticClass: "articleType col-sm-12"
  }, [_vm._v(_vm._s(_vm.issue.article_type ? _vm.issue.article_type.name : ''))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title col-sm-12",
    domProps: {
      "innerHTML": _vm._s(_vm.issue.title)
    }
  }, [_vm._v(_vm._s(_vm.issue.title))])])])]) : _vm._e(), _vm._v(" "), (!_vm.hideType) ? _c('div', {
    staticClass: "articleType",
    class: {
      'hidden-sm-down': _vm.smallMode
    }
  }, [_vm._v(_vm._s(_vm.issue.article_type ? _vm.issue.article_type.name : ''))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title",
    class: {
      'hidden-sm-down': _vm.smallMode
    },
    domProps: {
      "innerHTML": _vm._s(_vm.issue.title)
    }
  }, [_vm._v(_vm._s(_vm.issue.title))]), _vm._v(" "), _c('div', {
    staticClass: "row mb-4 no-gutters"
  }, [_c('div', {
    staticClass: "col-md-auto",
    class: {
      'hidden-sm-down': _vm.smallMode
    }
  }, [(_vm.coverUrl) ? _c('img', {
    staticClass: "issue-cover mb-3",
    attrs: {
      "src": _vm.coverUrl
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md col-sm-12"
  }, [_c('div', {
    staticClass: "doi"
  }, [_vm._v("DOI: "), _c('span', [_vm._v(_vm._s(_vm.issue.ids ? _vm.issue.ids.doi : ''))]), _vm._v("  \n                      pp " + _vm._s(_vm.issue.page_start) + "-" + _vm._s(_vm.issue.page_end) + "\n      ")]), _vm._v(" "), _c('div', {
    class: {
      'hidden-sm-down': _vm.smallMode
    }
  }, [_c('issue-authors', {
    attrs: {
      "authors": _vm.issue.authors
    }
  })], 1), _vm._v(" "), _c('article-quick-links', {
    attrs: {
      "article": _vm.issue
    }
  }), _vm._v(" "), (_vm.issue.abstract) ? _c('div', {
    staticClass: "abstract",
    class: {
      hide: !_vm.isAbstractShow
    },
    domProps: {
      "innerHTML": _vm._s(_vm.issue.abstract)
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c00bc10a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/CondensedIssueComponent.vue
// module id = 1473
// module chunks = 1